/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import InputContainer from '../../form/inputs/InputContainer';
import { TextualInputProps } from '@/shared/types/form-input';
import InputFill from '../../form/inputs/InputFill';

export type TextAreaInputProps = Omit<TextualInputProps, "type" | "name"> & {
  name?: string;
};

const TextAreaInput: Component<TextAreaInputProps> = ({
  name,
  disabled = false,
  leftAdornment,
  rightAdornment,
  rows = 1,
  sx,
  ...props
}) => {
  // Calculate height based on rows (1rem base font size * rows * 2 for line height)
  const height = `calc(1rem * ${rows * 2})`;

  return (
    <InputContainer name={name ?? ''} size="auto" sx={{ height: height, ...sx }}>
      {leftAdornment}
      <InputFill name={name ?? ''} {...props} asTextArea sx={{ py: "0.5rem" }} disabled={disabled} />
      {rightAdornment}
    </InputContainer>
  );
};

export default TextAreaInput;
